import { render, staticRenderFns } from "./Journals.vue?vue&type=template&id=1417f0af&scoped=true"
import script from "./Journals.vue?vue&type=script&lang=js"
export * from "./Journals.vue?vue&type=script&lang=js"
import style0 from "./Journals.vue?vue&type=style&index=0&id=1417f0af&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1417f0af",
  null
  
)

export default component.exports